/*jslint browser: true, vars: true, nomen: true, indent: 4, maxlen: 80, plusplus: true, sloppy: true, newcap: true, sub: true, regexp: true, continue: true*/
/*global console: true, changyan: true, require: true, module: true*/

var $$events = require('./event.js');
var dataCollection = {};
var _ = window._;
var model = (function () {
    function Model(data, fn) {
        if (!_.isObject(data)) {
            return this;
        }
        this.id = _.uniqueId('Model_');
        dataCollection[this.id] = data;
        if (_.isFunction(fn)) {
            fn();
        }
    }

    Model.prototype.get = function (key) {
        return dataCollection[this.id][key];
    };

    Model.prototype.has = function (key) {
        return _.has(dataCollection[this.id], key);
    };

    Model.prototype.set = function (key, value) {
        var changing, prev, current, temp = {};
        if (key === null) {
            return this;
        }
        if (!this.has(key)) {
            return this;
        }
        changing = this._changing;
        this._changing = true;

        if (!changing) {
            this._previousData = _.clone(dataCollection[this.id]);
            this.changed = {};
        }
        temp[key] = value;
        dataCollection[this.id] = _.extend(dataCollection[this.id], temp);
        current = dataCollection[this.id];
        prev = this._previousData;

        if (!_.isEqual(current[key], prev[key])) {
            $$events.trigger(this.id + key, dataCollection[this.id]);
        }

        if (changing) {
            return this;
        }

        this._changing = false;
    };

    Model.prototype.on = function (str, fn) {
        try {
            if (!_.isFunction(fn) || !_.isString(str)) {
                throw 'error params';
            }
        } catch (e) {}

        $$events.on(this.id + str, fn);
    };

    Model.prototype.once = function (str, fn) {
        try {
            if (!_.isFunction(fn) || !_.isString(str)) {
                throw 'error params';
            }
        } catch (e) {}

        $$events.once(this.id + str, fn);
    };

    Model.prototype.trigger = function (str, data) {
        try {
            if (!_.isString(str)) {
                throw 'error params';
            }
        } catch (e) {}

        $$events.trigger(this.id + str, data);
    };

    return Model;
}());

module.exports = model;


// WEBPACK FOOTER //
// ./src/assets/util/model.js